import axios, { AxiosError } from 'axios'

export type ParcelInfoType = {
  deliveryCompanyName: string
  message: string
}
export const parcelinfo = async (sessionId: string, data: ParcelInfoType): Promise<void> => {
  try {
    const url = `${process.env.REACT_APP_API_SERVER}/v1/parcelinfo`
    await axios.post(url, data, { headers: { authorization: `Bearer ${sessionId}` } })

    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error as AxiosError)
  }
}
